import { Stack } from '@mui/material';
import { PriceControlAggregatedInfo } from './PriceControlAggregatedInfo';
import { PriceControlSuppliersTable } from './PriceControlSuppliersTable';
import { useNavigate } from 'react-router';
import { mgPrisRoutes } from '@retail/mgpris/config';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useFetchPriceControlAggregated } from '@retail/price-control/data-access';
import { PriceControlAggregated } from '@retail/price-control/types';
import { ErrorFallback, SuspenseWithSentryErrorBoundary } from '@retail/components';

export function PriceControlSuppliersView() {
  const navigate = useNavigate();
  const { assortmentId } = useSelectedOrgUnit();

  const onSupplierClick = (supplierNumber: number) => {
    navigate(mgPrisRoutes.priceControl.supplier.getFullLinkPath({ supplierNumber }));
  };
  const { data: priceControlAggregatedDTO, isLoading } = useFetchPriceControlAggregated(
    assortmentId,
    { suspense: false }
  );
  const priceControlAggregated = priceControlAggregatedDTO
    ? PriceControlAggregated.fromDto(priceControlAggregatedDTO)
    : undefined;

  return (
    <Stack flexGrow={1} width="100%" gap={2}>
      <PriceControlAggregatedInfo
        priceControlAggregated={priceControlAggregated}
        isLoading={isLoading}
      />
      <SuspenseWithSentryErrorBoundary
        errorFallback={
          <Stack flexGrow={1} justifyContent="center">
            <ErrorFallback />
          </Stack>
        }
      >
        <PriceControlSuppliersTable
          suppliersPriceControl={priceControlAggregated?.suppliers ?? []}
          isLoadingSuppliers={isLoading}
          onSupplierClick={onSupplierClick}
        />
      </SuspenseWithSentryErrorBoundary>
    </Stack>
  );
}
